<p-card [header]="isEditMode ? 'Update Payment Code' : 'Create Payment Code'">
    <form [formGroup]="createPaymentTermsForm" style="height: 100vh;">

        <div class="col">

            <div class="field col-12 flex justify-content-between align-items-center"> 
                <div class="flex justify-content-start">
                    <p-button [label]="isEditMode ? 'Update' : 'Save'" icon="pi pi-save" size="small"
                        (click)="savePaymentTerms(createPaymentTermsForm.value, isEditMode)"></p-button>
                    <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" (click)="Cancel()"
                        class="p-button-sm ml-2"></p-button>
                </div>

                <div>
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>
                </div>
            </div>

        </div>

        <div class="card flex justify-content-end mr-2">
            <p-checkbox formControlName="isActive" [binary]="true" inputId="binary" value="isActive"  label="Active"></p-checkbox>
        </div>
        <div class="grid">
            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">Payment Terms Code</label>
                    <input pInputText placeholder="e.g: Payment Terms 20" [readonly]="isEditMode" formControlName="termsCode" (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.termsCode.errors }"
                        class="w-full p-inputtext-sm" />
                    <small *ngIf="submitted && formControls.termsCode.errors" id="termsCode-error" class="text-red-500">Required
                        field.</small>
                </div>

                <div class="field text-left">
                    <label for="website" class="label-required display">Payment Discount %</label>
                    <input pInputText type="number" placeholder="e.g: 20" formControlName="discount" (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.discount.errors }"
                        class="w-full p-inputtext-sm" />
                    <small *ngIf="submitted && formControls.discount.errors" id="discount-error" class="text-red-500">Required
                        field.</small>
                </div>

                <div class="field text-left">
                    <label for="website" class="label-required display">Conditional Discount (Days)</label>
                    <input pInputText type="number" placeholder="e.g: 25" formControlName="conditionalDiscount" (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.conditionalDiscount.errors }"
                        class="p-inputtext-sm" style="width: 91%;"/><label class="ml-2"> days</label>
                    <small *ngIf="submitted && formControls.conditionalDiscount.errors" id="conditionalDiscount-error" class="text-red-500">Required
                        field.</small>
                </div>

                <div class="field text-left">
                    <label for="website" class="label-required display">Net Due Days</label>
                    <input pInputText type="number" placeholder="e.g: 30" formControlName="netDue" (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.netDue.errors }"
                        class="p-inputtext-sm" style="width: 91%;"/><label class="ml-2"> days</label>
                    <small *ngIf="submitted && formControls.netDue.errors" id="netDue-error" class="text-red-500">Required
                        field.</small>
                </div>
            </div>

            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">Payment Description</label>
                    <textarea pInputText placeholder="e.g: Add your terms and conditions" style="height: 18rem;" class="w-full p-inputtext-sm" formControlName="paymentTermsDescription"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.paymentTermsDescription.errors }"></textarea>
                    <small *ngIf="submitted && formControls.paymentTermsDescription.errors" id="unitsofMeasureDescription-error" class="text-red-500">Required
                        field.</small>
                </div>
            </div>
        </div>

    </form>
</p-card>

<p-toast></p-toast>

